import { render, staticRenderFns } from "./Annuity.vue?vue&type=template&id=029630a0"
import script from "./Annuity.vue?vue&type=script&lang=js"
export * from "./Annuity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports